export const PAYPAL = 'PAYPAL';
export const CARD = 'CARD';